/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const OrganizePDFFileFormats = {
  file_formats: [
    {
      doc: {
        mime_type: "application/msword"
      }
    },
    {
      doc: {
        mime_type: "application/xml"
      }
    },
    {
      bmp: {
        mime_type: "image/bmp"
      }
    },
    {
      jpeg: {
        mime_type: "image/jpeg"
      }
    },
    {
      jpg: {
        mime_type: "image/jpeg"
      }
    },
    {
      png: {
        mime_type: "image/png"
      }
    },
    {
      gif: {
        mime_type: "image/gif"
      }
    },
    {
      docx: {
        mime_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      }
    },
    {
      ppt: {
        mime_type: "application/vnd.ms-powerpoint"
      }
    },
    {
      pptx: {
        mime_type: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
      }
    },
    {
      pptx: {
        mime_type: "application/mspowerpoint"
      }
    },
    {
      pptx: {
        mime_type: "application/x-tika-ooxml"
      }
    },
    {
      rtf: {
        mime_type: "text/rtf"
      }
    },
    {
      text: {
        mime_type: "text/plain"
      }
    },
    {
      txt: {
        mime_type: "text/plain"
      }
    },
    {
      txt: {
        mime_type: "message/rfc822"
      }
    },
    {
      vtt: {
        mime_type: "text/vtt"
      }
    },
    {
      xls: {
        mime_type: "application/vnd.ms-excel"
      }
    },
    {
      xls: {
        mime_type: "application/msexcel"
      }
    },
    {
      xlsx: {
        mime_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    },
    {
      xls: {
        mime_type: "application/x-tika-msworks-spreadsheet"
      }
    }
  ]
};

export default OrganizePDFFileFormats;
